import { render, staticRenderFns } from "./AccountInformations.vue?vue&type=template&id=bc27b258&scoped=true"
import script from "./AccountInformations.vue?vue&type=script&lang=js"
export * from "./AccountInformations.vue?vue&type=script&lang=js"
import style0 from "./AccountInformations.vue?vue&type=style&index=0&id=bc27b258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc27b258",
  null
  
)

export default component.exports